import { render, staticRenderFns } from "./PetracersLogo.vue?vue&type=template&id=10a50012&scoped=true&"
var script = {}
import style0 from "./PetracersLogo.vue?vue&type=style&index=0&id=10a50012&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a50012",
  null
  
)

export default component.exports